import React from 'react';
import T from 'prop-types';

import Tooltip from '../../../../components/Tooltip';
import { Menu, MenuItem, MenuButton, useMenuProps } from '../../../../components/DropdownSet';
import { SCHEDULED_EXPORTS_LIMIT } from '../../../../components/AdvancedExportModal/configs/constants';

const ActionsDropdown = ({
  item,
  size,
  isDuplicateDisabled,
  isDeleteDisabled,
  scheduleLimitReached,
  onEdit,
  onRename,
  onDuplicate,
  onDelete,
  onSchedule,
  onScheduleUpdate,
  onScheduleCancel,
}) => {
  const menuProps = useMenuProps({
    align: 'end',
    overflow: 'visible',
    viewScroll: 'close',
    menuStyle: { width: 204 },
    className: 'actions-dropdown-menu',
  });

  const renderScheduleMenuItems = () => {
    if (item.scheduled) {
      return (
        <>
          {onScheduleUpdate && (
            <MenuItem onClick={() => onScheduleUpdate(item)}>
              <i className="hicon-calendar-thin-round" />
              Modify Schedule
            </MenuItem>
          )}
          {onScheduleCancel && (
            <MenuItem onClick={() => onScheduleCancel(item)}>
              <i className="hicon-ban" />
              Cancel Schedule
            </MenuItem>
          )}
        </>
      );
    }

    return onSchedule ? (
      <Tooltip
        content={
          scheduleLimitReached
            ? `You have reached your maximum allowed scheduled exports (${SCHEDULED_EXPORTS_LIMIT})`
            : null
        }
        colorVariant="light"
      >
        <MenuItem
          disabled={scheduleLimitReached}
          onClick={() => !scheduleLimitReached && onSchedule(item)}
        >
          <i className="hicon-calendar-thin-round" />
          Schedule
        </MenuItem>
      </Tooltip>
    ) : null;
  };

  return (
    <div className="actions-dropdown-container">
      <Menu
        menuButton={
          <MenuButton size={size} shape="square" caret={false} variant="light">
            <i className="hicon-more-vert" />
          </MenuButton>
        }
        {...menuProps}
      >
        {onEdit && (
          <MenuItem onClick={() => onEdit(item)}>
            <i className="hicon-edit-2" />
            Edit Export
          </MenuItem>
        )}
        <MenuItem onClick={() => onRename(item)}>
          <i className="hicon-rename" />
          Rename
        </MenuItem>
        <MenuItem
          disabled={isDuplicateDisabled}
          onClick={() => !isDuplicateDisabled && onDuplicate(item)}
        >
          <i className="hicon-duplicate" />
          Duplicate
        </MenuItem>
        {renderScheduleMenuItems()}
        <MenuItem
          disabled={isDeleteDisabled}
          className={isDeleteDisabled ? '' : 'text-rose'}
          onClick={() => !isDeleteDisabled && onDelete(item)}
        >
          <i className="hicon-remove" />
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

ActionsDropdown.propTypes = {
  item: T.object.isRequired,
  size: T.oneOf(['sm']),
  isDuplicateDisabled: T.bool,
  isDeleteDisabled: T.bool,
  scheduleLimitReached: T.bool,
  onEdit: T.func,
  onSchedule: T.func,
  onScheduleUpdate: T.func,
  onScheduleCancel: T.func,
  onRename: T.func.isRequired,
  onDuplicate: T.func.isRequired,
  onDelete: T.func.isRequired,
};

export default ActionsDropdown;
